import { Fragment, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import clsx from "clsx";
import {
  LEFT_OFFSET,
  SLOT_HEIGHT,
  useDailyCalendarStyles,
} from "../edReviewCalendarDaily";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { isModifying } from "../../../../../../store/reducers/reviews";
import moment from 'moment';

const START_OF_DAY = new Date().setHours(0, 0, 0, 0);
const END_OF_DAY = new Date().setHours(23, 59, 59, 999);

export const TimeColumn = () => {
  const classes = useDailyCalendarStyles();

  const [timeSlots, setTimeSlots] = useState([]);

  useEffect(() => {
    const slots = [];
    let currentDay = START_OF_DAY;

    while (currentDay <= END_OF_DAY) {
      slots.push(new Date(currentDay));
      currentDay += 30 * 60 * 1000;
    }

    setTimeSlots(slots);
  }, []);

  return (
    !isEmpty(timeSlots) &&
    timeSlots.map((timeSlot, index) => {
      const isEven = index % 2 === 0;
      const time = moment(timeSlot).format(window.envConfig.defaultTimeFormat);

      return (
        <Grid
          item
          key={`${time}${Math.random()}`}
          className={clsx(classes.time, !isEven && "odd")}
          style={{
            height: SLOT_HEIGHT,
            position: "sticky",
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
          {isEven && time}
        </Grid>
      );
    })
  );
};

const TimeSlots = ({ width }) => {
  const classes = useDailyCalendarStyles();

  const isManupulationStateModifying = useSelector(isModifying);

  const [timeSlots, setTimeSlots] = useState([]);

  useEffect(() => {
    const slots = [];
    let currentDay = START_OF_DAY;

    while (currentDay <= END_OF_DAY) {
      slots.push(new Date(currentDay));
      currentDay += 30 * 60 * 1000;
    }

    setTimeSlots(slots);
  }, [width]);

  const isRenderHorizontalLine = useCallback(
    (timeslotIndex) => {
      return (
        (timeslotIndex === 0 || timeSlots.length - 1 !== timeSlots.length) &&
        timeslotIndex % 2 === 0
      );
    },
    [timeSlots.length],
  );

  return (
    !isEmpty(timeSlots) &&
    timeSlots.map((timeSlot, index) => {
      const slotTopPosition = index * SLOT_HEIGHT;

      return (
        <Fragment key={index}>
          {isRenderHorizontalLine(index) && (
            <span
              // key={index}
              style={{
                width,
                zIndex: isManupulationStateModifying ? 100 : 400,
                left: LEFT_OFFSET,
                top: slotTopPosition,
                minWidth: `calc(100% - ${2 * LEFT_OFFSET})`,
              }}
              className={clsx(classes.timelineSlot, "borderBottom")}
            />
          )}
        </Fragment>
      );
    })
  );
};

TimeSlots.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default TimeSlots;
